





































































import Vue from 'vue';
import Component from 'vue-class-component';

const Props = Vue.extend({
	props: {
		mois: {
			type: Number,
			default: 156
		}
	},
	methods: {
		// Test si l'age sélectionné contient des liens utiles
		isLiensUtiles: function() {
			let json: any= this.$t('components.santeenfant.developpement.mois'+this.mois);
			if (json.liens) {
				return true;
			}
			return false;
		}
	}
});

@Component({})
export default class SonDeveloppement extends Props {
}
